import { LessonModel, TeacherModel } from "redux/models/home";
import { axiosClient } from "./client";
import {
  GET_EXPERT_COUNT,
  GET_EXPERT_COUNTRIES,
  GET_FAMOUS_EXPERTS,
  GET_NEW_COMER_EXPERTS,
  GET_TOP_PAGE_LESSONS,
  GET_TOP_PAGE_LESSONSBY_TAGS,
  GET_TOP_PAGE_LESSONS_WITH_AUTH,
  GET_TOP_PAGE_TEACHERS,
  GET_TOP_PAGE_TEACHERS_WITH_AUTH,
  LESSONS_TAGS,
  SET_BOOKMARK_TEACHER,
  SET_FAVOURITE_LESSON,
  RATE_TEACHER,
  GET_EXPERT_COUNTRIES_FLAT
} from "./client/endpoints";
import { SUCCESS_STATUS } from "utils/constants";

const fetchExpertCountries = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_EXPERT_COUNTRIES);
    return response.data;
  } catch (e) {
    return null;
  }
};

const fetchExpertCountriesFlat = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_EXPERT_COUNTRIES_FLAT);
    return response.data;
  } catch (e) {
    return null;
  }
};

const fetchFamousExperts = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_FAMOUS_EXPERTS);
    return response.data;
  } catch (e) {
    return null;
  }
};

const fetchNewComerExperts = async (): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(GET_NEW_COMER_EXPERTS, {
      to: 3,
    });
    return response.data;
  } catch (e) {
    return null;
  }
};
const fetchExpertCount = async (): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(GET_EXPERT_COUNT);
    return response.data;
  } catch (e) {
    return null;
  }
};

const fetchHomePageLessonsByTags = async (
  tag: string
): Promise<LessonModel[]> => {
  const response = await axiosClient.get<{ data: { data: LessonModel[] } }>(
    `${GET_TOP_PAGE_LESSONSBY_TAGS}?tags${tag ? `[0]=${tag}` : ""}`
  );
  return response?.data?.data?.data;
};

const fetchHomePagePopularLessons = async (
  auth: boolean = false
): Promise<LessonModel[]> => {
  const response = await axiosClient.get<{ data: { data: LessonModel[] } }>(
    auth ? GET_TOP_PAGE_LESSONS_WITH_AUTH : GET_TOP_PAGE_LESSONS
  );
  return response?.data?.data?.data;
};

const fetchHomePageTeachers = async (
  auth: boolean = false
): Promise<TeacherModel[]> => {
  const response = await axiosClient.get<{ data: { data: TeacherModel[] } }>(
    auth ? GET_TOP_PAGE_TEACHERS_WITH_AUTH : GET_TOP_PAGE_TEACHERS
  );
  return response?.data?.data?.data;
};

const setFavouriteLesson = async (id: number): Promise<boolean> => {
  const response = await axiosClient.post<any>(
    `${SET_FAVOURITE_LESSON}?lesson_id=${id}`
  );
  return response?.status === SUCCESS_STATUS;
};

const setBookmarkTeacher = async (id: number): Promise<boolean> => {
  const response = await axiosClient.post<any>(
    `${SET_BOOKMARK_TEACHER}?teacher_id=${id}`
  );
  return response?.status === SUCCESS_STATUS;
};

const getLessonsTags = async (): Promise<string[]> => {
  const response = await axiosClient.get<{ data: string[] }>(LESSONS_TAGS);
  return response?.data?.data;
};

const setTeacherRating = async (data: any): Promise<boolean> => {
  const response = await axiosClient.post<any>(RATE_TEACHER, data
  );
  return response?.status === SUCCESS_STATUS;
};

const HomeService = {
  fetchExpertCountries,
  fetchExpertCountriesFlat,
  fetchFamousExperts,
  fetchNewComerExperts,
  fetchExpertCount,
  fetchHomePageLessonsByTags,
  fetchHomePagePopularLessons,
  fetchHomePageTeachers,
  setFavouriteLesson,
  setBookmarkTeacher,
  getLessonsTags,
  setTeacherRating
};

export default HomeService;
